import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { calculateFreightSuccess } from '../../store/ducks/freight/actions';

export enum freightTypeEnum {
  PRIVATE = 'Privado',
  PUBLIC = 'Publico',
  INTERNAL = 'Interno',
}

interface IConfigureFreightData {
  driverId?: string;
  vehicleId?: string;
  freightRequestId: string;
  totalWeight: number;
  totalDeliveries: number;
  totalValue: number;
  numberOfHelpers: number;
  vehicleTypeId?: string;
  extraCartIds?: string[];
  pickUpDate?: string;
  pickUpTime?: string;
  deliveryLimitDate?: string;
  freightType?: string;
  percentageFreightCost?: string;
  waypoints?: (
    | {
        corporateName: any;
        before: string;
      }
    | {
        corporateName: any;
        before?: undefined;
      }
  )[];
}

export interface CalculateFreightResponse {
  totalKilometers: number;
  vehicleType: string;
  waypoints: string[];
  freightCost: number;
  totalValue: number;
  priceWithFee: number;
}

export function useConfigureFreight() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(
    body: IConfigureFreightData,
    callback?: () => void,
  ): Promise<CalculateFreightResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.post('v1/backoffice/configure-freight', {
        driverId: body.driverId,
        vehicleId: body.vehicleId,
        freightRequestId: body.freightRequestId,
        numberOfHelpers: body.numberOfHelpers,
        totalWeight: body.totalWeight,
        totalDeliveries: body.totalDeliveries,
        totalValue: body.totalValue,
        vehicleTypeId: body.vehicleTypeId,
        extraCartIds: body.extraCartIds,
        pickUpDate: body.pickUpDate,
        pickUpTime: body.pickUpTime,
        deliveryLimitDate: body.deliveryLimitDate,
        freightType: body.freightType,
        waypoints: body.waypoints,
        percentageFreightCost: body.percentageFreightCost,
      });

      if (response.status === 201) {
        console.log('[useConfigureFreight] Resposta 201 recebida:', {
          freightCost: response.data.freightCost,
          priceWithFee: response.data.priceWithFee,
          totalValue: response.data.totalValue,
          totalKilometers: response.data.totalKilometers,
        });
        
        dispatch(
          calculateFreightSuccess({
            totalValue: response.data.totalValue,
            deliveries: response.data.deliveries,
            freightCost: response.data.freightCost,
            totalKilometers: response.data.totalKilometers,
            priceWithFee: response.data.priceWithFee,
            vehicleType: response.data.vehicleType,
            numberOfHelpers: body.numberOfHelpers,
            totalWeight: body.totalWeight,
          }),
        );

        if (callback) {
          callback();
        }
        return response.data;
      } else {
        console.warn('[useConfigureFreight] Status diferente de 201:', response.status);
        return undefined;
      }
    } catch (error: any) {
      console.error('[useConfigureFreight] Erro na requisição:', {
        message: error?.message,
        response: error?.response?.data,
        status: error?.response?.status,
      });
      toast.error(ToastMessages.general.error.genericError);
      return undefined;
    } finally {
      setLoading(false);
    }
  }
  return {
    execute,
    loading,
  };
}
